/**
 * Check if the URL is a favourite page
 * @param {string} url - The URL to check
 * @return {boolean} true if the URL is a favourite page, else false
 */
const isFavouritePage = (url) => {
    return url.includes('favourites');
};
export default isFavouritePage;
//# sourceMappingURL=isFavouritePage.js.map